import { jsx as _jsx } from "react/jsx-runtime";
import { Image } from "semantic-ui-react";
import { LoyaltyTierProvider, useLoyaltyContext } from "@iscr/cosmetics/loyalty/LoyaltyTierProvider";
export function LoyaltyBadge() {
    const { currentUserOrgTier, loyaltyEnabled } = useLoyaltyContext();
    const src = !currentUserOrgTier
        ? undefined
        : {
            Silver: "/icosm/images/badges/Loyalty-Tier-Icon-Silver.png",
            Gold: "/icosm/images/badges/Loyalty-Tier-Icon-Gold.png",
            Platinum: "/icosm/images/badges/Loyalty-Tier-Icon-Platinum.png",
        }[currentUserOrgTier.name];
    return !currentUserOrgTier || !src || !loyaltyEnabled ? null : (_jsx(Image, { className: "w-14 inline", src: src, alt: `${currentUserOrgTier.name} tier` }));
}
export function LoyaltyBadgeWithProvider() {
    return (_jsx(LoyaltyTierProvider, { children: _jsx(LoyaltyBadge, {}) }));
}
